import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './team.css'

const Team = (props) => {
  // Team member data
  const teamMembers = [
    {
      name: props.member3 || 'Lucie',
      image: 'https://fitelites3.s3.eu-central-1.amazonaws.com/images/holka3.webp',
      alt: props.member3Alt
    },
    {
      name: props.member1 || 'Alina',
      image: 'https://fitelites3.s3.eu-central-1.amazonaws.com/images/holka2.webp',
      alt: props.member1Alt
    },
    {
      name: props.member2 || 'Adéla',
      image: 'https://fitelites3.s3.eu-central-1.amazonaws.com/images/holka1.webp',
      alt: props.member2Alt
    }
  ]

  return (
    <div
      id={props.teamId}
      className={`team-section thq-section-padding ${props.rootClassName}`}
    >
      <div className="team-max-width thq-section-max-width">
        {/* Section Header */}
        <div className="team-section-title">
          <div className="team-content">
            <h2 className="team-heading thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="team-text-heading">Náš tým</span>
                </Fragment>
              )}
            </h2>
            <p className="team-description thq-body-large">
              {props.content2 ?? (
                <Fragment>
                  <span className="team-text-description">
                    Poznej náš tým{' '}
                    <span className="team-text-highlight">sportovně</span>
                    {' '}založených recepčních.
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>

        {/* Team Members Grid */}
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <img
                alt={member.alt}
                src={member.image}
                className="team-image thq-img-ratio-1-1 thq-img-round"
              />
              <div className="team-info">
                <h3 className="team-name thq-body-small">
                  {typeof member.name === 'string' ? member.name : member.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

Team.defaultProps = {
  member1: undefined,
  member3: undefined,
  member1Alt: 'Member Alt',
  heading1: undefined,
  member2: undefined,
  member2Alt: 'Member Alt',
  content2: undefined,
  member3Alt: 'Member Alt',
  teamId: '',
  rootClassName: '',
}

Team.propTypes = {
  member1: PropTypes.element,
  member3: PropTypes.element,
  member1Alt: PropTypes.string,
  heading1: PropTypes.element,
  member2: PropTypes.element,
  member2Alt: PropTypes.string,
  content2: PropTypes.element,
  member3Alt: PropTypes.string,
  teamId: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Team
